module.exports = __webpack_public_path__ + "fonts/OpenSans-BoldItalic.a1860f91.woff2";